import {
  BorderRadius8,
  Box,
  Checkbox,
  GreyGrey30,
  GreyWhite,
  Primary13SemiBold,
  ShadowM
} from '@sequencehq/core-components'
import {
  CustomerEmptyStateAction,
  IntegrationCustomerEmptyState
} from './IntegrationCustomerEmptyState'
import { IntegrationCustomerRow } from './IntegrationCustomerRow'
import { SelectableCustomer } from './integrationCustomer.types'

export type SelectAllControl = {
  selectableCount: number
  allSelected: boolean
  onToggle: () => void
}

export const IntegrationCustomerList = (props: {
  action: CustomerEmptyStateAction
  customers: SelectableCustomer[]
  search: string
  selectedCustomerIds: string[]
  onToggleCustomer: (id: string) => void
  blockInvalidSelection: boolean
  integrationName?: string | null
  hasActiveFilters: boolean
  onClearFilters: () => void
  unfilteredCustomerCount: number
  allCustomersLinked: boolean
  selectAll?: SelectAllControl
  'data-testid': string
}) => {
  const dataTestId = props['data-testid']

  return (
    <Box
      width="100%"
      height="100%"
      overflow="auto"
      border={`1px solid ${GreyGrey30}`}
      borderRadius={BorderRadius8}
      data-testid={`${dataTestId}.list`}
    >
      {props.selectAll && props.selectAll.selectableCount > 0 && (
        <Box
          borderBottom={`1px solid ${GreyGrey30}`}
          padding="16px 24px"
          width="100%"
          position="sticky"
          top="0"
          backgroundColor={GreyWhite}
          boxShadow={ShadowM}
        >
          <Checkbox
            data-testid={`${dataTestId}.selectAll`}
            label={
              <Box as="span" {...Primary13SemiBold} userSelect="none">
                Select all ({props.selectAll.selectableCount})
              </Box>
            }
            isChecked={props.selectAll.allSelected}
            onChange={props.selectAll.onToggle}
          />
        </Box>
      )}
      {props.customers.length > 0 ? (
        props.customers.map(customer => (
          <IntegrationCustomerRow
            key={customer.id}
            customer={customer}
            search={props.search}
            isSelected={props.selectedCustomerIds.includes(customer.id)}
            isDisabled={props.blockInvalidSelection && customer.isDisabled}
            integrationName={props.integrationName}
            onToggle={() => props.onToggleCustomer(customer.id)}
            data-testid={`${dataTestId}.customer.${customer.id}`}
          />
        ))
      ) : (
        <IntegrationCustomerEmptyState
          action={props.action}
          filters={{
            hasActiveFilters: props.hasActiveFilters,
            onClear: props.onClearFilters
          }}
          unfilteredCustomerCount={props.unfilteredCustomerCount}
          allCustomersLinked={props.allCustomersLinked}
          integrationName={props.integrationName}
          data-testid={`${dataTestId}.emptyState`}
        />
      )}
    </Box>
  )
}
